/* tslint:disable */
/* eslint-disable */
/**
 * BlackFriday API
 * The API Documentation for BlackFriday
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import type { GenericIdDTO } from "./GenericIdDTO";
import { GenericIdDTOFromJSON, GenericIdDTOFromJSONTyped, GenericIdDTOToJSON } from "./GenericIdDTO";

/**
 *
 * @export
 * @interface PatchManyExternalDealFiltersLiveDTO
 */
export interface PatchManyExternalDealFiltersLiveDTO {
  /**
   *
   * @type {Array<GenericIdDTO>}
   * @memberof PatchManyExternalDealFiltersLiveDTO
   */
  filterIds: Array<GenericIdDTO>;
  /**
   *
   * @type {boolean}
   * @memberof PatchManyExternalDealFiltersLiveDTO
   */
  live: boolean;
}

/**
 * Check if a given object implements the PatchManyExternalDealFiltersLiveDTO interface.
 */
export function instanceOfPatchManyExternalDealFiltersLiveDTO(value: object): boolean {
  let isInstance = true;
  isInstance = isInstance && "filterIds" in value;
  isInstance = isInstance && "live" in value;

  return isInstance;
}

export function PatchManyExternalDealFiltersLiveDTOFromJSON(json: any): PatchManyExternalDealFiltersLiveDTO {
  return PatchManyExternalDealFiltersLiveDTOFromJSONTyped(json, false);
}

export function PatchManyExternalDealFiltersLiveDTOFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PatchManyExternalDealFiltersLiveDTO {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    filterIds: (json["filterIds"] as Array<any>).map(GenericIdDTOFromJSON),
    live: json["live"]
  };
}

export function PatchManyExternalDealFiltersLiveDTOToJSON(value?: PatchManyExternalDealFiltersLiveDTO | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    filterIds: (value.filterIds as Array<any>).map(GenericIdDTOToJSON),
    live: value.live
  };
}
